import React, { FC, SyntheticEvent } from 'react';
import { useQuery } from '@apollo/client';
import { getOrderPriceSpecTemplate } from 'apollo/templates/order';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import PriceSpecificationSection from 'components/order-flow/action-order/confirm-step/price-specification-section/price-specification-section.componet';
import { useTranslation } from 'react-i18next';
import DelayedLinearProgress from 'components/shared/delayed-linear-progress/delayed-linear-progress.component';

type orderPriceSpecDialogProps = {
    onClose: () => void;
    open: boolean;
    orderId: string;
    price: number | null;
};

const OrderPriceSpecDialog: FC<orderPriceSpecDialogProps> = ({
    onClose,
    open,
    orderId,
    price,
}: orderPriceSpecDialogProps) => {
    const { t: translate } = useTranslation(['orders']);
    const { showBoundary } = useDenthubErrorBoundary();

    const { data: { order } = {}, loading } = useQuery(getOrderPriceSpecTemplate, {
        variables: { orderId },
        onError: showBoundary,
    });

    const handleCloseDialog = (e: SyntheticEvent) => {
        e.stopPropagation();
        onClose();
    };

    return (
        <DHDialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={handleCloseDialog}
            title={translate('orders:PRICE_SPECIFICATION')}
        >
            {loading || !order?.restorations ? (
                <DelayedLinearProgress />
            ) : (
                <PriceSpecificationSection
                    restorations={order?.restorations || []}
                    totalPrice={price || 0}
                    currency={order?.currency}
                />
            )}
        </DHDialog>
    );
};

export default OrderPriceSpecDialog;
